import { ReactNode } from 'react';

import { Icon } from '@purpur/library/icon';
import { checkCircle } from '@purpur/library/icon/assets/check-circle';
import { error } from '@purpur/library/icon/assets/error';
import { time } from '@purpur/library/icon/assets/time';
import { toast as coreToast, Id, ToastOptions } from 'react-toastify';

import { CustomToastButton, CustomToastContent, CustomToastText } from './Toast.styles';

type CustomToastOptions = ToastOptions & {
    onClick?: () => void;
    buttonText?: string;
};

const showToast = (content: ReactNode, options?: CustomToastOptions) => {
    const { type, onClick, toastId, buttonText } = options || {};
    const toastContent = () => (
        <CustomToastContent data-test={`toast-${type}`}>
            <Icon svg={(type === 'success' && checkCircle) || (type === 'error' && error) || time} size="md" />
            <CustomToastText>{content}</CustomToastText>
            <CustomToastButton onClick={() => (onClick ? onClick() : toastClose(toastId))}>
                {buttonText || 'Uždaryti'}
            </CustomToastButton>
        </CustomToastContent>
    );

    return coreToast(toastContent, {
        ...options,
        updateId: toastId,
    });
};

export const toastMessage = (content: ReactNode, options?: CustomToastOptions) => {
    return showToast(content, { ...options, type: options?.type || 'success' });
};

export const toastError = (content: ReactNode, options?: CustomToastOptions) => {
    return showToast(content, { ...options, type: 'error' });
};

export const toastClose = (toastId?: Id) => {
    coreToast.dismiss(toastId);
};

export const isToastActive = (toastId: Id) => {
    return coreToast.isActive(toastId);
};
